import { render, staticRenderFns } from "./TagAddModal.vue?vue&type=template&id=5e1ae3b4&scoped=true&"
import script from "./TagAddModal.vue?vue&type=script&lang=js&"
export * from "./TagAddModal.vue?vue&type=script&lang=js&"
import style0 from "./TagAddModal.vue?vue&type=style&index=0&id=5e1ae3b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1ae3b4",
  null
  
)

export default component.exports